module.exports = __webpack_public_path__ + "fonts/notonaskharabicui-bold-webfont.ba515ecf.woff";